import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { fetchContent, fetchPhotos } from "@/lib/api";

const SiteContext = createContext(null);

export const SiteProvider = ({ children }) => {
  const [lang, setLang] = useState("zh");
  const [content, setContent] = useState(null);
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const [c, p] = await Promise.all([fetchContent(), fetchPhotos()]);
      setContent(c);
      setPhotos(p);
    } catch (e) {
      console.error("Failed to load site data", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    if (!content) return;
    if (window.location.pathname !== "/") return;
    const zh = lang === "zh";
    document.documentElement.lang = zh ? "zh-CN" : "en";
    document.title = zh
      ? "i.S.i Group | 人寿·医疗·车险·家庭财富规划"
      : "i.S.i Group | Life · Medical · Auto · Family Wealth Planning";
    const desc = document.querySelector('meta[name="description"]');
    if (desc) {
      desc.setAttribute(
        "content",
        zh
          ? "i.S.i Group——一支年轻的保险顾问团队，提供人寿重疾、医疗保险、车险财产与家庭财富规划服务，24 小时在线。"
          : "i.S.i Group — young, caring advisors for life, medical, auto insurance and family wealth planning."
      );
    }
  }, [lang, content]);

  const t = useCallback(
    (obj, base) => {
      if (!obj) return "";
      return obj[`${base}_${lang}`] ?? obj[`${base}_zh`] ?? "";
    },
    [lang]
  );

  return (
    <SiteContext.Provider value={{ lang, setLang, content, setContent, photos, refresh, loading, t }}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSite = () => useContext(SiteContext);
